export function isLegacyAgentVersion(version) {
  return !isModernAgentVersion(version)
}

export function isLegacyXappMonitorAgent(agent) {
  const name = String(agent?.name || '')
    .trim()
    .toLowerCase()
  return name === 'xapp-monitor' && isLegacyAgentVersion(agent?.version)
}

export function isModernAgentVersion(version) {
  const normalized = String(version || '').trim()
  if (!normalized) return false
  const match = normalized.match(/^(\d+)\.(\d+)\.(\d+)/)
  if (!match) return false

  const major = Number.parseInt(match[1], 10)
  const minor = Number.parseInt(match[2], 10)
  const patch = Number.parseInt(match[3], 10)

  if (
    !Number.isFinite(major) ||
    !Number.isFinite(minor) ||
    !Number.isFinite(patch)
  ) {
    return false
  }

  if (major > 2) return true
  if (major < 2) return false
  if (minor > 0) return true
  if (minor < 0) return false
  return patch >= 0
}
